module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p24"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "arial"
    }
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_vm._v("Korean Short Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("Buy the small pieces of short rib, ones that the butcher has cut across the bone into about 1-inch sections. They cook fast and, once they make it to the platter, they’re gone just as quickly.")])])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5 color-3C1C00"
  }, [_vm._v("Serves ")]), _c('span', {
    staticClass: "yield color-FF5100"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("6 ")])]), _c('span', {
    staticClass: "yield color-3C1C00"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("to ")])]), _c('span', {
    staticClass: "yield color-FF5100"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("8 ")])]), _c('span', {
    staticClass: "yield color-3C1C00"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("as an appetizer")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11"
  }, [_vm._v("½ ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("cups white wine "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11"
  }, [_vm._v("¾")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("cup soy sauce "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("bunch scallions, green parts only, finely chopped "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("tablespoons coarsely chopped fresh ginger "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("8")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("cloves garlic, coarsely chopped "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("6")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("tablespoons brown sugar "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("teaspoon Chinese five-spice powder "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("pounds beef short ribs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "method_text"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-FFDingbats-ArrowsOne-11_1-14"
  }, [_vm._v("→")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Combine ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the white wine, soy sauce, scallions (reserve ½ cup for garnish), ginger, garlic, brown sugar, and five-spice powder in a Dutch oven. Add the short ribs and bring the liquid to a simmer over medium-high heat. Immediately reduce the heat to low, cover the pot, and simmer the short ribs for 1 hour.")])])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Using ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("a slotted spoon, transfer the ribs to a bowl or plastic container. Skim the fat from the cooking liquid and pour the liquid back over the ribs. The ribs can be cooked to this point up to 2 days before grilling. Store them, covered, in the refrigerator and bring to room temperature before grilling.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("To ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("finish the ribs, prepare enough coals for a hot charcoal fire, or preheat your gas grill on high for 10 minutes with the lid closed.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("When ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the coals are ready or the gas grill is hot, arrange the ribs on the grill so they aren’t touching, and grill for 7 to 8 minutes, until they are slightly charred outside and heated through in the center. Turn the ribs several times, mopping each time with the leftover sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Transfer ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the ribs to a platter and serve hot or at room temperature, garnished with the reserved chopped scallions.")])])])]), _c('a', {
    attrs: {
      "id": "p24"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c62059","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/016chapter10.vue
// module id = 102
// module chunks = 0